import {getAssetTypeDescriptor} from './asset-type.registry';

import type {AssetAttributes} from './asset-type.descriptor';
import type {AssetType} from '@sollapay/enums';

/** Joins the type's code prefix with its resolved segments; blank segments are skipped. */
export function buildAssetDisplayCode(assetType: AssetType, attributes: AssetAttributes): string {
  const descriptor = getAssetTypeDescriptor(assetType);

  const segments = descriptor.codeSegments
    .map(segment => {
      const value = attributes[segment.key]?.trim();
      return value ? `${segment.prefix ?? ''}${value}` : null;
    })
    .filter((value): value is string => !!value);

  return [descriptor.code, ...segments].filter((part): part is string => !!part).join('-');
}
